import { Injectable, ViewChild } from '@angular/core';
import { PouchdbService } from '../shared/pouchDb.service'
import * as _ from 'lodash';
import { ShelfValues, bookCategoeyEnums } from '../shared/models/shelfEnums';
import { BehaviorSubject } from 'rxjs/Rx';
import { MatSnackBar } from '@angular/material';

import PouchDB from 'pouchdb';
import PouchdbFind from 'pouchdb-find';
import { debug } from 'util';
import { Constants } from '../shared/models/constants'
import { Shelf } from '../shared/models/shelf';
import { Book } from '../shared/models/book';
import { BookData } from '../shared/models/bookData';
import { Page } from '../shared/models/page';
import { LiquidModel } from '../shared/models/liquidModel';
import { PageContent } from '../shared/models/pageContent';
import { Recents } from '../shared/models/recents';
import { BookTemplates } from '../shared/models/bookTemplates';
import { storeRecents } from '../shared/models/storeRecents';
import { InboxBids } from '../shared/models/inboxBids';
import { InboxBookData } from '../shared/models/inboxBookData';
import { IS_ElectronService } from '../shared/IS_Electron.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ShelfPouchDb {
    localDB; remoteDB;
    bookDataObj: BookData = new BookData();
    bookTemplates;
    allShelfData: any;
    uniquebookid;
    uniqBooksArray = [];
    formedBooksArr = [];
    draggedBookFrom;
    bulkDocArray = [];
    defaultShelfarray = [
        {
            "name": "Purchases",
            "category": 0
        },
        {
            "name": "Creations",
            "category": 1
        },
        {
            "name": "Imports",
            "category": 2
        },
        {
            "name": "Favourites",
            "category": 3
        }
    ];

    public removedShelf: any;
    cteatedMytemplates = [];
    shelfData;
    singleBookdata: any;
    uniqueBookArrayChildren: any;


    private updatingShelfsDataInAllComp = new BehaviorSubject<any>([]);
    interaction = this.updatingShelfsDataInAllComp.asObservable();



    constructor(public pouchService: PouchdbService, private ElectronService: IS_ElectronService, public snackBar: MatSnackBar, private translate: TranslateService) {
        this.localDB = this.pouchService.localDB;
        this.remoteDB = this.pouchService.remoteDB;
        if (!this.ElectronService.IS_ELECTRON)
            this.bookTemplates = Constants.getTemplates();
        else
            this.bookTemplates = Constants.getElectronTemplates();

    }
    ngOnInit() {
        this.isMythemesDocAvailable(this);
    }

    getShelfData(myCompThis, ind) {

        var self = this;
        // this.localDB = this.pouchService.localDB;
        // this.remoteDB = this.pouchService.remoteDB;

        this.pouchService.localDB.find({
            selector: { type: 'shelf' },
        }).then(function (result) {

            self.allShelfData = result.docs;
            // myCompThis.updateListOfShlefs(result.docs);
            self.updatingShelfsDataInAllComp.next(result.docs);
            localStorage.purchasesList = JSON.stringify(result.docs[0]);

            // preparing Default shelfs
            if (myCompThis.myContentElements.length == 0 && localStorage.defaultShelf != 'true' && localStorage.userData && localStorage.userData != 'undefined') {
                self.arrangingAndCreateDefaultShelfs()
            }

            if (localStorage.userData != 'undefined' && localStorage.userData != undefined) {



                if (localStorage.firstTimeloaded != 'true') {
                    self.getDefaultShelfBooks(myCompThis, ind);
                    localStorage.firstTimeloaded = 'true';

                }

                else {
                    self.pouchService.startDefaultReplication('state');
                    if (ind == 0) myCompThis.showAllBookRecords();
                    localStorage.isAppReloaded = false;
                    self.pouchService.syncingData.next('Data Pulled');

                }

            }
            else {
                if (ind == 0) myCompThis.showAllBookRecords();
            }


            // self.updateExportDetails();


            // self.updateInboxData();


        }).catch(function (err) {
        });

    }

    updateInboxData() {

        var self = this;
        self.pouchService.localDB.find({
            selector: { type: "inboxBids" },
        }).then(function (doc) {

            var result = doc.docs[0];

            self.pouchService.localDB.find({
                selector: { type: "export" },
            }).then(function (doc) {

                var exportresult = doc.docs;
                // parent.window.document['mycompthis'].getExportData(result, 0, exportresult);




            })
        })

    }

    getDefaultShelfBooks(myCompThis, ind) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'shelf' },
        }).then(function (result) {
            var bookIdsArr = [];
            _.forEach(result.docs, function (doc) {
                _.forEach(doc.bookIds, function (bid) {
                    bookIdsArr.push(bid);
                })
            })
            self.pouchService.getDefaultShelfBookDocs(bookIdsArr).then(function (result) {
                if (result == 'completed') {
                    if (ind == 0) myCompThis.showAllBookRecords();
                }
            });

        })

    }

    startReplicationTo() {

        this.pouchService.startReplicationTo();
    }

    preparedBookIdsDataArray = [];

    prepareInboxIdsDoc(inboxDocs) {
        var self = this;
        if (inboxDocs)
            for (var i = 0; i < this.formedBooksArr.length; i++) {
                var bookarray = this.formedBooksArr[i];
                var inboxBookArray = inboxDocs[bookarray.book._id];
                if (inboxBookArray) {
                    for (var j = 0; j < inboxBookArray.length; j++) {
                        for (var k = 0; k < this.formedBooksArr[i].booksArray.length; k++) {
                            if (inboxBookArray[j].bids == this.formedBooksArr[i].booksArray[k]._id) {
                                this.formedBooksArr[i].booksArray[k].isDownloaded = inboxBookArray[j].isDownloaded;
                            }
                        }
                    }
                }
            }
        parent.window.document['mycompthis'].getExportData(self.formedBooksArr);
    }


    addBooksIntoRecents(book) {
        var recents = new Recents()
        var self = this;
        // var temp = {
        //     id: book._id,
        //     timestamp: Math.round(new Date().getTime() / 1000)
        // }
        this.pouchService.localDB.find({
            selector: { _id: recents._id },
        }).then(function (doc) {
            let index = _.findIndex(doc.docs[0].bookIds, function (o: any) { return o == book._id; });
            if (index != -1) {

                doc.docs[0].bookIds.splice(index, 1);
                doc.docs[0].bookIds.splice(0, 0, book._id);
                // doc.docs[0].bookIds.push(book._id);
                return self.pouchService.localDB.put(doc.docs[0]);
            }
            else {
                // doc.docs[0].bookIds.push(book._id);

                doc.docs[0].bookIds.splice(0, 0, book._id);
                return self.pouchService.localDB.put(doc.docs[0]).then(function (result) {
                }).catch(function (err) {
                });
            }

            // doc.docs[0].bookIds.push(temp);
            // return self.pouchService.localDB.put(doc.docs[0]);
        })
    }

    formAllShelfsArray() {

        let appThis = parent.window.document['mycompthis'];
        appThis.allShelfElements = [];
        appThis.myContentElements.forEach(element => {

            var obj = {
                'shelfName': element.title,
                'data': [],
                '_id': element._id
            }

            if (element.bookIds.length > 0) {

                this.pouchService.localDB.find({
                    selector: { type: 'book', _id: { $in: element.bookIds } },
                }).then(function (result) {
                    obj.data = result.docs;
                    appThis.allShelfElements.push(obj);

                }).catch(function (err) {
                });
            }
        });
    }


    getShelfChildren(doc) {
        var self = this;
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'shelf', _id: { $in: doc.children } },
            }).then(function (result) {
                resolve(result.docs)
            }).catch(function (err) {
            });
        });
    }

    getRecentData(myContentThis) {

        return new Promise((resolve, reject) => {
            var self = this;
            var recents = new Recents()

            this.pouchService.localDB.find({
                selector: { _id: recents._id },
            }).then(function (result) {
                var a = [];
                if (result.docs.length == 0) {
                    resolve(a);
                    return
                }
                for (var i = 0; i < result.docs[0].bookIds.length; i++) {
                    a.push(result.docs[0].bookIds[i]);
                }
                self.pouchService.localDB.find({
                    selector: { type: 'book', _id: { $in: a } },
                }).then(function (result) {
                    // myContentThis.allRecentFiles = result.docs;
                    console.log(a);
                    var allBooks = [];
                    for (var i = 0; i < a.length; i++) {
                        var ind = _.findIndex(result.docs, function (o: any) { return o._id == a[i]; });
                        allBooks.push(result.docs[ind]);
                    }
                    resolve(allBooks);
                    // myContentThis.recentsDataUpdated();


                }).catch(function (err) {
                });

            }).catch(function (err) {
            });
        })

    }



    isRecentsDocAvailable() {
        // this.localDB = this.pouchService.localDB;
        // this.remoteDB = this.pouchService.remoteDB;
        return new Promise((resolve, reject) => {
            var self = this;
            var recents = new Recents()
            this.pouchService.localDB.find({
                selector: { _id: recents._id },
            }).then(function (doc) {
                if (!doc.docs.length) {
                    self.pouchService.localDB.put(recents).then(function (res) {
                        resolve(res)
                        // mycompthis.pouchservice.getRecentData(mycompthis)
                    })
                }
                else {
                    resolve(this);
                    //    mycompthis.pouchservice.getRecentData(mycompthis)
                }
            })
        })
    }


    getBookData(list) {
        var self = this;
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'book', _id: { $in: list.bookIds } },
            }).then(function (result) {

                var order = list.bookIds;
                var booksData = []
                for (var n = 0; n < order.length; n++) {
                    var book = _.filter(result.docs, function (filter) { return filter._id == order[n] });
                    if (book[0]) {
                        booksData.push(book[0])
                    }
                }
                resolve(booksData)
            }).catch(function (err) {
            });
        });
    }


    getBookDataObjForExport(list) {

        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'bookData', _id: list.bookDataDocId },
            }).then(function (result) {

                resolve(result.docs);

            }).catch(function (err) {
            });

        })


    }

    createShelf(doc) {
        var self = this;

        return new Promise((resolve, reject) => {
            self.pouchService.localDB.put(doc).then(function (result) {
                self.openSnackBar('Shelf Created Successfully', '');
                resolve(true)
            }).catch(function (err) {
            })
        });

    }


    updateFavBook(data) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'book', _id: data._id },
        }).then(function (doc) {
            // doc.docs[0] = data;
            data._rev = doc.docs[0]._rev;
            data._id = doc.docs[0]._id;
            self.pouchService.localDB.put(data).then(function (res) {

                self.updateFavShelf(data);

            }).catch(function (err) {
            })
        })

    }


    updateFavShelf(book) {
        var self = this;
        var id = Constants.USER + '.04.Favourites';
        this.pouchService.localDB.find({
            selector: { type: 'shelf', _id: id },
        }).then(function (doc) {
            var index = _.findIndex(doc.docs[0].bookIds, function (o: any) { return o == book._id; });

            if (index != -1) {
                doc.docs[0].bookIds.splice(index, 1);
            } else {
                doc.docs[0].bookIds.push(book._id);
            }

            self.pouchService.localDB.put(doc.docs[0]).then(function (res) {

                var ind = self.getIndForGettingShelfData();
                // self.getShelfData(parent.window.document['mycompthis'], ind);
                self.alternateGetShelfData(ind);
            })
        })

    }

    createSubShelf(doc) {

        var self = this;
        var currentDoc = doc

        return new Promise((resolve, reject) => {
            this.pouchService.localDB.put(doc).then(function (result) {
                self.pouchService.localDB.find({
                    selector: { type: 'shelf', _id: currentDoc.parentId },
                }).then(function (doc) {
                    doc.docs[0].children.push(currentDoc._id);
                    return self.pouchService.localDB.put(doc.docs[0]);
                }).then(function (response) {

                    // self.getShelfData(compThis, ind);
                    // self.alternateGetShelfData(ind);
                    self.openSnackBar('Sub Shelf Created Successfully', '');
                    resolve(true)

                }).catch(function (err) {
                    console.log(err);
                });
            }).catch(function (err) {
            })

        });
    }

    updateShelfObject(data) {

        var self = this;

        this.pouchService.localDB.find({
            selector: { type: 'shelf', _id: data._id },
        }).then(function (doc) {
            doc.docs[0].title = data.title;
            return self.pouchService.localDB.put(doc.docs[0]);
        }).then(function (response) {

            // self.getShelfData(mycompThis, 0);

        }).catch(function (err) {
            console.log(err);
        });
    }

    getbookDataObj(bookObj) {
        var self = this;
        return new Promise((resolve, reject) => {
            if (bookObj.bookDataDocId == undefined)
                bookObj.bookDataDocId = "Not Defined";
            this.pouchService.localDB.find({
                selector: { type: 'bookData', _id: bookObj.bookDataDocId },
            }).then(function (result) {
                if (result.docs.length > 0)
                    resolve(result.docs[0])
                else {
                    self.checkandCreateBookData(bookObj);
                }
            }).catch(function (err) {
            });
        })
    }
    checkandCreateBookData(book) {
        var self = this;
        if (book.bookCategory == 1)//created
        {
            if (book.bookType == 1) { // ebe
                self.setBookDataObj(book);

            }
            if (book.bookType == 3) {// ele
                self.setELEBookDataObj(book);

            }

        }
        else {
            this.bookDataObj = new BookData();
            this.bookDataObj.bookDocId = book._id;
            this.bookDataObj._id = Constants.USER + "." + book.bId + ".bookData";
        }

        self.pouchService.localDB.put(self.bookDataObj).then(function (response) {

        }).catch(function (err) {
            console.log(err);
        });
        book.bookDataDocId = self.bookDataObj._id;
        self.pouchService.localDB.put(book).then(function (response) {
            self.getbookDataObj(book);
        }).catch(function (err) {
            console.log(err);
        });

    }
    addBookIntoShelf(ind, list, book) {
        var self = this;

        this.pouchService.localDB.put(book).then(function (result) {
            var temp = result;

            self.pouchService.localDB.find({
                selector: { type: 'bookData', _id: book.bookDataDocId },
            }).then(function (result) {
                if (result.docs.length == 0) {
                    self.checkandCreateBookData(book);
                }

            }).catch(function (err) {

            });

            self.pouchService.localDB.find({
                selector: { type: 'shelf', category: ShelfValues.Creations },
            }).then(function (doc) {
                // doc.docs[0].bookIds.push(result.id);
                doc.docs[0].bookIds.splice(0, 0, result.id);
                return self.pouchService.localDB.put(doc.docs[0]);
            }).then(function (response) {

                if (list.shelfType == 'Default') {
                    // self.getShelfData(parentThis, ind);
                    self.alternateGetShelfData(ind);
                }
                else {
                    self.addReferenceBook(list, book, ind)
                }
                self.openSnackBar('Book Created Successfully' , '');
            }).catch(function (err) {
                console.log(err);
            });
        }).catch(function (err) {
        })
    }

    setELEBookDataObj(book) {
        var pageContents = [];
        this.bookDataObj = new BookData();
        this.bookDataObj.bookDocId = book._id;
        this.bookDataObj._id = Constants.USER + "." + book.bId + ".bookData";

        // var timeStamp = Math.round(new Date().getTime() / 1000);
        var timeStamp = Constants.getGUID();
        this.bookDataObj.lastOpenedPage = timeStamp;

        var page: Page = new Page();
        page.id = timeStamp;
        var liquidModel: LiquidModel = new LiquidModel();

        var pageContent: PageContent = new PageContent();
        pageContent._id = Constants.USER + "." + page.id + ".pageContent";

        pageContent.pageContent = liquidModel;
        pageContent.bookDocId = book._id;
        page.contentDocId = pageContent._id;
        page.title = 'Page ' + page.pageNumber;
        pageContents.push(pageContent);
        this.bookDataObj[page.id + ""] = page;
        this.bookDataObj.pages.push(page.id + "");

        this.createELEPageContentDocs(pageContents[0], timeStamp);

    }
    createELEPageContentDocs(pageContents, timeStamp) {
        var self = this;
        self.pouchService.localDB.put(pageContents).then(function (result) {
        }).catch(function (err) {
        })
    }

    setCustomTemplateBookPageDataNBookData(pageContent, book, page, pageContents) {
        pageContent.bookDocId = book._id;
        pageContents.push(pageContent);
        page.contentDocId = pageContent._id;
        this.bookDataObj[page.id + ""] = page;
        this.bookDataObj.pages.push(page.id + "");
    }

    //To prepare book data for custom templates
    async setCustomTemplateBookDataObj(book, bookDataObj, templateObj) {

        var pageContents = [];
        let ind = _.findIndex(this.cteatedMytemplates, function (o) { return o._id == book.templateId; });
        let mytemplate = this.cteatedMytemplates[ind];
        var self = this;
        const j = 3;
        for (let i = 1; i <= j; i++) {

            var page: Page = new Page();
            page.id = Constants.getGUID();
            var liquidModel: LiquidModel = new LiquidModel();
            var pageContent: PageContent = new PageContent();
            pageContent._id = Constants.USER + "." + page.id + ".pageContent";
            if (i == 1) {
                page.title = 'Cover Page';
                page.type = 'blankPage';
                if (!(mytemplate.cover.contentDocId.length > 0)) {
                    liquidModel.pageBgStyle = { "type": "image", "url": templateObj.front_P, aspectRatio: true };
                    pageContent.pageContent = liquidModel;
                    self.setCustomTemplateBookPageDataNBookData(pageContent, book, page, pageContents);
                }
                else {
                    await this.getTemplatePageContent(mytemplate.cover.contentDocId).then(function (res) {
                        if (res) {
                            pageContent.pageContent = res['pageContent'];
                            self.setCustomTemplateBookPageDataNBookData(pageContent, book, page, pageContents);
                        }
                    });
                }
                this.bookDataObj.lastOpenedPage = page.id;
            }
            if (i == 2) {
                page.pageNumber = 1;
                page.title = 'Page' + page.pageNumber;
                page.type = 'blankPage';
                if (!(mytemplate.page.contentDocId.length > 0)) {
                    liquidModel.pageBgStyle = { "type": "image", "url": templateObj.page_P, aspectRatio: true };
                    pageContent.pageContent = liquidModel;
                    self.setCustomTemplateBookPageDataNBookData(pageContent, book, page, pageContents);
                }
                else {
                    await this.getTemplatePageContent(mytemplate.page.contentDocId).then(function (res) {
                        if (res) {
                            pageContent.pageContent = res['pageContent'];
                            self.setCustomTemplateBookPageDataNBookData(pageContent, book, page, pageContents);
                        }
                    });
                }
            }
            if (i == 3) {
                page.title = 'End Page';
                page.type = 'blankPage';
                if (!(mytemplate.back.contentDocId.length > 0)) {
                    liquidModel.pageBgStyle = { "type": "image", "url": templateObj.back_P, aspectRatio: true };
                    pageContent.pageContent = liquidModel;
                    self.setCustomTemplateBookPageDataNBookData(pageContent, book, page, pageContents);
                }
                else {
                    await this.getTemplatePageContent(mytemplate.back.contentDocId).then(function (res) {
                        if (res) {
                            pageContent.pageContent = res['pageContent'];
                            self.setCustomTemplateBookPageDataNBookData(pageContent, book, page, pageContents);
                        }
                    });
                }
            }
        }
        self.createPageContentDocs(pageContents);
        //To update bookData Obj again
        self.updateBookDataDoc();
    }

    updateBookDataDoc() {
        var self = this;
        self.pouchService.localDB.get(self.bookDataObj._id).then(function (doc) {
            // handle doc
            self.bookDataObj['_rev'] = doc._rev;
            self.pouchService.localDB.put(self.bookDataObj).then(function (response) {

            }).catch(function (err) {
                console.log(err);
            });
        }).catch(function (err) {
            console.log(err);
        });
    }

    setBookDataObj(book) {
        var pageContents = [];
        var templateObj;
        this.bookDataObj = new BookData();
        this.bookDataObj.bookDocId = book._id;
        this.bookDataObj._id = Constants.USER + "." + book.bId + ".bookData";
        // var timeStamp = Math.round(new Date().getTime() / 1000);
        var timeStamp = Constants.getGUID();
        if (!book.isCustomTemplate)
            templateObj = this.bookTemplates[book.templateId + ""];
        else {
            templateObj = this.getCustomTemplate(book.templateId);
            //To prepare book data for custom templates
            this.setCustomTemplateBookDataObj(book, this.bookDataObj, templateObj);
            return;
        }

        for (var i = 1; i <= 3; i++) {
            var page: Page = new Page();
            // page.id = timeStamp++;
            page.id = Constants.getGUID();
            var liquidModel: LiquidModel = new LiquidModel();
            var pageContent: PageContent = new PageContent();
            pageContent._id = Constants.USER + "." + page.id + ".pageContent";
            if (i == 1) {
                liquidModel.pageBgStyle = { "type": "image", "url": templateObj.front_P, aspectRatio: true };
                this.bookDataObj.lastOpenedPage = page.id;
                page.title = 'Cover Page';
            }
            if (i == 2) {
                page.pageNumber = 1;
                liquidModel.pageBgStyle = { "type": "image", "url": templateObj.page_P, aspectRatio: true };
                page.title = 'Page' + page.pageNumber;
            }
            if (i == 3) {
                liquidModel.pageBgStyle = { "type": "image", "url": templateObj.back_P, aspectRatio: true };
                page.title = 'End Page';
            }
            page.type = 'blankPage';
            pageContent.bookDocId = book._id;
            pageContent.pageContent = liquidModel;
            page.contentDocId = pageContent._id;
            pageContents.push(pageContent);

            this.bookDataObj[page.id + ""] = page;
            this.bookDataObj.pages.push(page.id + "");

        }

        this.createPageContentDocs(pageContents);

    }
    getCustomTemplate(id) {

        var ind = _.findIndex(this.cteatedMytemplates, function (o) { return o._id == id; });
        var template = this.cteatedMytemplates[ind];
        var currTemplateObj = {
            "name": "CustomTemplate",
            "ID": id,
            "back_P": template.back.thumbUrl,
            "backThumb": template.back.thumbUrl,
            "card": template.cover.thumbUrl,
            "front_P": template.cover.thumbUrl,
            "frontThumb": template.cover.thumbUrl,
            "page_P": template.page.thumbUrl,
            "pageThumb": template.page.thumbUrl,
            "type": template.page.type //type - 0 for Image and type - 1 for Template, where type represents page in book
        };

        return currTemplateObj;
    }

    getTemplatePageContent(id) {
        var self = this;

        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'pageContent', _id: id },
            }).then(function (result) {
                if (result.docs.length > 0) {
                    resolve(result.docs[0]);
                }
            }).catch(function (err) {

            });
        });
    }


    createPageContentDocs(pageContents) {
        var self = this;
        self.pouchService.localDB.bulkDocs(pageContents, function (err, response) {
            if (err) {
                return console.log(err);
            } else {
                console.log("Documents created Successfully");
            }
        }).then(function (result) {
        }).catch(function (err) {
        })
    }


    addReferenceBook(list, newBook, ind) {
        var self = this;
        // newBook._rev = null;
        // delete newBook["_rev"];
        // newBook._id = Constants.USER + "." + Math.round(new Date().getTime() / 1000) + ".book";
        newBook.reference = list._id;


        this.pouchService.localDB.put(newBook).then(function (result) {
            self.pouchService.localDB.find({
                selector: { type: 'shelf', _id: list._id },
            }).then(function (doc) {
                // doc.docs[0].bookIds.push(newBook._id);

                doc.docs[0].bookIds.splice(0, 0, newBook._id);
                return self.pouchService.localDB.put(doc.docs[0]);
            }).then(function (response) {

                // self.getShelfData(parentThis, ind);
                self.alternateGetShelfData(ind);

            }).catch(function (err) {
                console.log(err);
            });
        }).catch(function (err) {
            if (err.name == 'conflict') {
                self.addReferenceBook(list, newBook, ind)
            }
        });
    }


    updateShelfData(shelfObj, bookObj, state) {

        var ind = this.getIndForGettingShelfData()

        //  bookObj._rev = null;
        // delete bookObj["_rev"];
        var self = this;
        return new Promise((resolve, reject) => {

            this.pouchService.localDB.put(bookObj).then(function (result) {
                self.pouchService.localDB.find({
                    selector: { type: 'shelf', _id: shelfObj._id },
                }).then(function (doc) {
                    // doc.docs[0].bookIds.push(bookObj._id)
                    doc.docs[0].bookIds.splice(0, 0, bookObj._id);
                    return self.pouchService.localDB.put(doc.docs[0]);
                }).then(function (response) {
                    if (state) {
                        // self.getShelfData(mycompThis, ind);
                        self.alternateGetShelfData(ind);
                    }
                    resolve(true);
                }).catch(function (err) {
                    console.log(err);
                });
            })
        })
    }

    putDefaultShelfs(array) {

        var self = this;
        if (localStorage.defaultShelf == 'true') {
            // self.getShelfData(myCompthis, 0);
            self.alternateGetShelfData(0);
            return;
        }

        this.pouchService.localDB.find({
            selector: { type: 'shelf', title: 'Purchases' },
        }).then(function (doc) {
            if (doc.docs.length == 0) {
                self.pouchService.localDB.bulkDocs([array[0], array[1], array[2], array[3]]).then(function (result) {

                    // self.getShelfData(myCompthis, 0);
                    self.alternateGetShelfData(0);
                }).catch(function (err) {

                })
            }

        }).catch(function (err) {
            console.log(err);
        });
    }




    deleteShelf(doc) {

        var ind = this.getIndForGettingShelfData();
        let myCompThis = parent.window.document['mycompthis'];
        this.deleteAllBooksOnShelfDelete(doc);
        var self = this;
        if (doc.parentId != '') {
            var docInd = _.findIndex(myCompThis.myContentElements, function (o) {
                return o['_id'] == doc.parentId
            });
            if (docInd != -1) {

                this.pouchService.localDB.find({
                    selector: { type: 'shelf', _id: doc.parentId },
                }).then(function (result) {

                    var subShelfInd = _.findIndex(result.docs[0].children, function (o) { return o == doc._id });
                    result.docs[0].children.splice(subShelfInd, 1);
                    self.pouchService.localDB.put(result.docs[0]).then(function (result1) {
                        // self.getShelfData(myCompThis, ind);

                    });
                })
            }
        }


        this.pouchService.localDB.find({
            selector: { type: 'shelf', _id: doc._id },
        }).then(function (doc) {
            return self.pouchService.localDB.remove(doc.docs[0]._id, doc.docs[0]._rev);
        }).then(function (result) {
            // handle result
            myCompThis.myContentElements = _.remove(myCompThis.myContentElements, function (n) {
                self.removedShelf = n;
                return self.removedShelf._id != result.id;
            });
            self.openSnackBar('Shelf Deleted Successfully', '');
            // self.getShelfData(myCompThis, 0);
            self.alternateGetShelfData(0);

        }).catch(function (err) {
            console.log(err);
        });
    }



    deleteAllBooksOnShelfDelete(shelf) {
        var self = this;
        var bookDataIds = [];
        // this.deleteBookFromFavourites(shelf.bookIds).then(function(data){
        //     self.deleteBooksFromRecents(shelf.bookIds);
        // })
        this.pouchService.localDB.find({
            selector: { type: 'book', _id: { $in: shelf.bookIds } },
        }).then(async function (result) {

            var tempArr = [];
            for (var i = 0; i < result.docs.length; i++) {
                bookDataIds.push(result.docs[i].bookDataDocId);

                if (result.docs[i].reference == "") {
                    await self.pouchService.localDB.remove(result.docs[i]._id, result.docs[i]._rev);
                    tempArr.push(result.docs[i]._id);
                }
                else {
                    result.docs[i].reference = "";
                    await self.pouchService.localDB.put(result.docs[i]);
                }
            }

            if (bookDataIds.length) {
                self.deleteAllBookDataInformation(bookDataIds);
            }
            if (tempArr.length) {
                self.deleteBookFromFavourites(tempArr).then(function (data) {
                    self.deleteBooksFromRecents(tempArr);
                })
            }

        }).catch(function (err) {
        });
    }

    deleteAllBookDataInformation(ids) {

        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: { $in: ids } },
        }).then(function (result) {

            for (var i = 0; i < result.docs.length; i++) {
                self.pouchService.localDB.remove(result.docs[i]._id, result.docs[i]._rev);
            }

        }).catch(function (err) {
        });

    }

    deleteBookFromFavourites(ids) {

        var self = this;
        var id = Constants.USER + '.04.Favourites';;

        // delete from favourites
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'shelf', _id: id },
            }).then(function (res) {

                for (var i = 0; i < ids.length; i++) {
                    var bidIndex = _.findIndex(res.docs[0].bookIds, function (o: any) { return o == ids[i]; });
                    if (bidIndex != -1) {
                        res.docs[0].bookIds.splice(bidIndex, 1);
                    }
                }

                self.pouchService.localDB.put(res.docs[0]).then(function (res) {
                    resolve(true);
                })
            })
        })


    }

    deleteBooksFromRecents(ids) {
        var self = this;

        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'recents' },
            }).then(function (res) {
                for (var i = 0; i < ids.length; i++) {
                    var bidIndex = _.findIndex(res.docs[0].bookIds, function (o: any) { return o == ids[i]; });
                    if (bidIndex != -1) {
                        res.docs[0].bookIds.splice(bidIndex, 1);
                    }
                }
                self.pouchService.localDB.put(res.docs[0]).then(function (res) {
                    resolve(true);
                })
            })
        })

    }

    add() {
        this.pouchService.test();
    }


    deleteBookFromShelf(data, shelfId) {

        var self = this;

        // var myThis = parent.window.document['mycompthis'];
        var ind = this.getIndForGettingShelfData();
        var selectedList = this.getShelfById(shelfId);
        // deleting reference book
        if (data.reference != '' && data.reference == selectedList._id) {
            self.pouchService.localDB.find({
                selector: { type: 'shelf', _id: data.reference },
            }).then(function (res) {
                var index = _.findIndex(res.docs[0].bookIds, function (o) { return o == data._id });
                if (index != -1) {
                    res.docs[0].bookIds.splice(index, 1);
                }
                self.pouchService.localDB.put(res.docs[0]).then(function (res) {

                    // self.getShelfData(myThis, ind);
                    self.pouchService.localDB.find({
                        selector: { type: 'book', _id: data._id },
                    }).then(function (result) {
                        result.docs[0].reference = '';
                        self.pouchService.localDB.put(result.docs[0]).then(function (res) {
                            self.openSnackBar('Book Deleted Successfully', '');
                            self.alternateGetShelfData(ind);
                        })
                    });

                })
            })
            return;
        }
        else if (data.reference != '' && data.reference != selectedList._id) {
            this.removeBookIdInCreatedShelf(data);
        }

        var tempArr = [];
        tempArr.push(data._id);


        // deleting actual book
        this.pouchService.localDB.find({
            selector: { type: 'book', _id: data._id },
        }).then(function (doc) {
            return self.pouchService.localDB.remove(doc.docs[0]._id, doc.docs[0]._rev);
        }).then(function (result) {
            self.deleteBookFromFavourites(tempArr).then(function (data) {
                self.deleteBooksFromRecents(tempArr).then(function (res) {
                    // self.getShelfData(parent.window.document['mycompthis'], ind);
                    self.openSnackBar('Book Deleted Successfully', '');
                    self.alternateGetShelfData(ind);
                    setTimeout(function () {
                        document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
                    }, 1000);

                })

            })


        }).catch(function (err) {
            console.log(err);
        });


        self.deleteBookIdFromShelf(selectedList, data)
        self.deleteAllbookContent(data);
    }


    deleteBookIdFromShelf(selectedList, data) {
        var self = this;
        self.pouchService.localDB.find({
            selector: { type: 'shelf', _id: selectedList._id },
        }).then(function (res) {
            var index = _.findIndex(res.docs[0].bookIds, function (o) { return o == data._id });
            if (index != -1) {
                res.docs[0].bookIds.splice(index, 1);
            }
            self.pouchService.localDB.put(res.docs[0]).then(function (res) {
            })
        })
    }

    deleteAllbookContent(data) {

        var self = this;
        this.pouchService.localDB.find({
            selector: { bookDocId: data._id },
        }).then(function (result) {

            for (var i = 0; i < result.docs.length; i++) {
                self.pouchService.localDB.remove(result.docs[i]._id, result.docs[i]._rev);
            }
            setTimeout(function () {
                document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
            }, 1000);

        }).catch(function (err) {
            console.log(err);
        });
    }


    updateBookInfo(data, isGetData) {
        return new Promise((resolve, reject) => {

            var self = this;
            var ind = this.getIndForGettingShelfData();

            this.pouchService.localDB.find({
                selector: { type: 'book', _id: data._id },
            }).then(function (doc) {

                data._rev = doc.docs[0]._rev;
                data._id = doc.docs[0]._id;
                if (doc.docs[0].templateId != data.templateId) {
                    self.updateBookDataObj(data);
                }
                doc.docs[0] = data;
                self.pouchService.localDB.put(data).then(function (res) {

                    if (isGetData) {
                        // self.getShelfData(myThis, ind);
                        self.alternateGetShelfData(ind);
                    }

                    resolve(this)
                })
            })
        })
    }




    updateBookDataObj(book) {
        var _this = this;
        var bookTemplateObj = this.bookTemplates[book.templateId + ""];
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: book.bookDataDocId },
        }).then(function (result) {
            if (result.docs.length > 0) {
                var bookData = result.docs[0];
                for (let i = 0; i < bookData.pages.length; i++) {
                    if (i == 0)
                        _this.getPageContent(bookData[bookData.pages[i]].contentDocId, bookTemplateObj.front_P, bookData[bookData.pages[i]]);
                    else if (i == bookData.pages.length - 1)
                        _this.getPageContent(bookData[bookData.pages[i]].contentDocId, bookTemplateObj.back_P, bookData[bookData.pages[i]]);
                    else
                        _this.getPageContent(bookData[bookData.pages[i]].contentDocId, bookTemplateObj.page_P, bookData[bookData.pages[i]]);
                }
            }

        }).catch(function (err) {

        });


    }
    getPageContent(id, url, pageObj) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'pageContent', _id: id },
        }).then(function (result) {
            if (result.docs.length > 0) {
                var pageContent = result.docs[0];
                if (!pageObj.isCustomBg)
                    pageContent.pageContent.pageBgStyle.url = url
                return self.pouchService.localDB.put(pageContent).then(function (result) {

                }).catch(function (err) {

                })
            }
        }).catch(function (err) {

        });
    }


    deleteAllDocs() {
        var self = this;
        // this.pouchService.localDB.allDocs().then(function (result) {
        //     // Promise isn't supported by all browsers; you may want to use bluebird
        //     console.log(result);
        //     return Promise.all(result.rows.map(function (row) {
        //       return self.pouchService.localDB.remove(row.id, row.value.rev);
        //     }));
        //   }).then(function () {

        //   }).catch(function (err) {

        //   });


        // this.remoteDB.allDocs({include_docs: true}).then(allDocs => {
        //     return allDocs.rows.map(row => {
        //       return {_id: row.id, _rev: row.doc._rev, _deleted: true};
        //     });
        //   }).then(deleteDocs => {
        //     return self.remoteDB.bulkDocs(deleteDocs);
        //   });
    }

    moveBookToAnotherShelf(droppedAt, data) {
        var book = data.book;
        var dragFrom = data.draggingFrom;
        // var allShelfs = compThis.allShelfs;
        var self = this;
        var ind = this.getIndForGettingShelfData()


        this.draggedBookFrom = this.getShelfById(data.draggingFromId)
        // this.getShelfInfo(allShelfs, dragFrom)
        return new Promise((resolve, reject) => {
            //   delete book id from dragging shelf

            var isAvailable = this.draggedBookFrom;
            this.pouchService.localDB.find({
                selector: { type: 'shelf', _id: isAvailable._id },
            }).then(function (result) {
                var ind = _.findIndex(result.docs[0].bookIds, function (o) { return o == book._id; });
                if (ind != -1) {
                    result.docs[0].bookIds.splice(ind, 1);
                }
                self.pouchService.localDB.put(result.docs[0]).then(function (result) {
                    // self.getShelfData(compThis, ind);
                }).catch(function (err) {
                })
            }).catch(function (err) {
            });

            // adding book id into dropped shelf

            this.pouchService.localDB.find({
                selector: { type: 'shelf', _id: droppedAt._id },
            }).then(function (result) {
                // result.docs[0].bookIds.push(book._id);
                result.docs[0].bookIds.splice(0, 0, book._id);
                self.pouchService.localDB.put(result.docs[0]).then(function (result) {
                    // self.getShelfData(compThis, ind);  
                    // self.alternateGetShelfData(myThis, ind);
                    resolve(ind)
                }).catch(function (err) {
                })

            }).catch(function (err) {
            });
        });
    }

    dropShelfOnAnotherShelf(dragData, DropData) {
        var self = this;
        return new Promise((resolve, reject) => {
            if (dragData.parentId != "") {
                self.pouchService.localDB.find({
                    selector: { type: 'shelf', _id: dragData.parentId },
                }).then(function (result) {
                    var ind = _.findIndex(result.docs[0].children, function (o) { return o == dragData._id; });
                    if (ind != -1) {
                        result.docs[0].children.splice(ind, 1);
                    }
                    self.pouchService.localDB.put(result.docs[0]).then(function (result) {

                    }).catch(function (err) {
                    })

                }).catch(function (err) {
                });
            }

            this.pouchService.localDB.find({
                selector: { type: 'shelf', _id: dragData._id },
            }).then(function (result) {
                result.docs[0].parentId = DropData._id;
                self.pouchService.localDB.put(result.docs[0]).then(function (result) {

                    self.pouchService.localDB.find({
                        selector: { type: 'shelf', _id: DropData._id },
                    }).then(function (data) {
                        data.docs[0].children.push(dragData._id);

                        self.pouchService.localDB.put(data.docs[0]).then(function (result) {
                            resolve(true)
                        }).catch(function (err) {
                        })

                    }).catch(function (err) {
                    });
                }).catch(function (err) {
                })
            }).catch(function (err) {
            });
        });
    }


    addMyTemplateDoc(theme, name) {

        var self = this;
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.put(theme).then(function (result) {
                self.addIdsIntoThemes(theme._id).then(function (result) {
                    let info = {
                        _id: theme._id,
                        name: name
                    }
                    resolve(info);
                    // myCompThis.addingCreatingTemplateBook(theme._id, name);
                })
            }).catch(function (err) {
            })
        });
    }


    isMythemesDocAvailable(myCompThis) {
        var self = this;
        var bookTemplates = new BookTemplates();
        bookTemplates._id = Constants.USER + ".bookTemplates";
        this.pouchService.localDB.find({
            selector: { type: 'bookTemplates' },
        }).then(function (result) {
            if (!result.docs.length) {
                self.pouchService.localDB.put(bookTemplates);
            } else {
                self.getMyTemplateObjectes(myCompThis, result.docs[0]);
            }
        }).catch(function (err) {
        });
    }

    getMyTemplateObjectes(myCompThis, obj) {

        var self = this;
        return new Promise((resolve, reject) => {


            this.pouchService.localDB.find({
                selector: { type: 'bookTemplate', _id: { $in: obj.themeIds } },
            }).then(function (result) {

                myCompThis.cteatedMytemplates = result.docs;
                self.cteatedMytemplates = result.docs;
                resolve(result)
            }).catch(function (err) {
            });

        })
    }

    addIdsIntoThemes(id) {
        var self = this;

        return new Promise((resolve, reject) => {

            this.pouchService.localDB.find({
                selector: { type: 'bookTemplates' },
            }).then(function (doc) {
                doc.docs[0].themeIds.push(id);
                var bookTemplatesObj = doc.docs[0];
                self.pouchService.localDB.put(doc.docs[0]).then(function (data) {
                    var myCompThis = parent.window.document['mycompthis'];
                    self.getMyTemplateObjectes(myCompThis, bookTemplatesObj).then(function (result) {
                        resolve(doc)
                    })

                })
            }).catch(function (err) {
                console.log(err);
            });

        })

    }




    deletePrevReferenceBook(bookId, shelfId) {
        var self = this;
        return new Promise((resolve, reject) => {

            this.pouchService.localDB.find({
                selector: { type: 'shelf', _id: shelfId },
            }).then(function (result) {

                var index = _.findIndex(result.docs[0].bookIds, function (o: any) { return o == bookId; });
                if (index != -1) {
                    result.docs[0].bookIds.splice(index, 1);
                }

                self.pouchService.localDB.put(result.docs[0]).then(function (data) {
                    resolve(data)
                })
            }).catch(function (err) {
            });


        })
    }

    dragAndDropBookOnOtherBook(ev, droppedAt, state) {
        var self = this;
        return new Promise((resolve, reject) => {
            if (ev.draggingFrom) {
                if ((ev.draggingFrom == 'Purchases' || ev.draggingFrom == 'Creations' || ev.draggingFrom == 'Imports' || ev.draggingFrom == 'Favourites')) {
                    if (ev.book.reference != '') {
                        self.deletePrevReferenceBook(ev.book._id, ev.book.reference).then(function (res) {
                            ev.book.reference = droppedAt._id;
                            self.updateShelfData(droppedAt, ev.book, state).then(function (res) {
                                resolve(state);
                            })
                        })
                    }
                    else {
                        ev.book.reference = droppedAt._id;
                        self.updateShelfData(droppedAt, ev.book, state).then(function (res) {
                            resolve(state);
                        })
                    }
                }
                else if (droppedAt.shelfType != "created") {
                    return;
                }
                else {
                    if (ev.book.reference != '') {
                        self.deletePrevReferenceBook(ev.book._id, ev.book.reference).then(function (res) {
                            ev.book.reference = droppedAt._id;
                            self.updateBookInfo(ev.book, false);
                            self.moveBookToAnotherShelf(droppedAt, ev).then(function (res) {
                                self.alternateGetShelfData(res);
                                resolve(state);
                            })
                        })
                    }
                    else {
                        self.moveBookToAnotherShelf(droppedAt, ev).then(function (res) {
                            self.alternateGetShelfData(res);
                            resolve(state);
                        })
                    }
                }
            }

        });
    }


    getShelfById(id) {
        var currentShelf = _.filter(this.allShelfData, function (o) { return o._id == id; });
        return currentShelf[0];
    }

    removeBookIdInCreatedShelf(data) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'shelf', _id: data.reference },
        }).then(function (doc) {
            if (doc.docs.length) {
                let index = _.findIndex(doc.docs[0].bookIds, function (o: any) { return o == data._id; });
                if (index != -1) {
                    doc.docs[0].bookIds.splice(index, 1);
                    return self.pouchService.localDB.put(doc.docs[0]);
                }
            }
        });
    }




    alternateGetShelfData(ind) {
        var self = this;
        let myCompThis = parent.window.document['mycompthis'];
        this.pouchService.localDB.find({
            selector: { type: 'shelf' },
        }).then(function (result) {
            self.allShelfData = result.docs;
            // myCompThis.updateListOfShlefs(result.docs);
            if (result.docs.length == 0) {
                self.arrangingAndCreateDefaultShelfs();
                return;
            }

            self.updatingShelfsDataInAllComp.next(result.docs);
            localStorage.purchasesList = JSON.stringify(result.docs[0]);
            if (ind == 0 && myCompThis.showAllBookRecords) myCompThis.showAllBookRecords();
        });
    }

    getIndForGettingShelfData() {
        let myCompThis = parent.window.document['mycompthis'];
        var ind = myCompThis.selectedTabList
        if (ind == undefined) {
            ind = 0;
        }
        else {
            ind = ind + 1
        }
        return ind;
    }

    arrangingAndCreateDefaultShelfs() {
        var self = this;
        self.bulkDocArray = [];
        self.defaultShelfarray.forEach(function (item, index) {
            var shelfObj = new Shelf();
            shelfObj.createdAt = Math.round(new Date().getTime() / 1000);
            shelfObj.owner = Constants.USER;
            shelfObj.title = item.name;
            shelfObj.shelfType = "Default";
            shelfObj.category = item.category;
            shelfObj._id = Constants.USER + ".0" + (index + 1) + "." + item.name;
            self.bulkDocArray.push(shelfObj);
        })
        self.putDefaultShelfs(self.bulkDocArray);
    }

    openSnackBar(message: string, action: string) {
        var self = this;
        this.translate.get(message).subscribe((res) => {
            self.snackBar.open(res, action, {
                panelClass: ['snack-bar-color'],
                duration: 2000,
            });
        });
    }


    removeBookIdsFromRecents() {
        return new Promise((resolve, reject) => {
            var self = this;
            var recents = new Recents()

            this.pouchService.localDB.find({
                selector: { _id: recents._id },
            }).then(function (result) {
                result.docs[0].bookIds = [];
                self.pouchService.localDB.put(result.docs[0]).then(function (data) {
                    console.log('recents Empty')
                })

            }).catch(function (err) {
            });
        })
    }

    updateMyContentElements() {
        let myCompThis = parent.window.document['mycompthis'];
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'shelf' },
            }).then(function (result) {
                resolve(result.docs)
            });
        });
    }
    addimportfile(drivedata) {

        var self = this;
        this.pouchService.localDB.put(drivedata).then(function (result) {
            self.pouchService.localDB.find({
                selector: { type: 'shelf', category: ShelfValues.Imports },
            }).then(function (doc) {

                doc.docs[0].bookIds.push(result.id);

                return self.pouchService.localDB.put(doc.docs[0]);
            })



        }).catch(function (err) {

        })
        // this.pouchService.localDB.put(drivedata).then(function (result) {
        //     // alert('Shelf Created');

        // }).catch(function (err) {
        // })
    }
}  



// WEBPACK FOOTER //
// ./src/app/shelf/shelf.pouchdb.service.ts